import appointment from './appointment'
import patient from './patient'
import questionnaire from './questionnaire'
import medication from './medication'

export default {
    appointment,
    patient,
    questionnaire,
    medication
}
